import roundToPrecision from './roundToPrecision';

const calculateBmi = (height, weight) => {
  if (!height || height <= 0 || !weight || weight <= 0) {
    return 0;
  }

  return roundToPrecision(weight / ((height * height) / (100 * 100)), 2);
};

export default calculateBmi;
